import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	full: {
		"& > *": {
			borderBottom: "unset",
			backgroundColor: theme.palette.custom.indicator.full,
		},
	},
	partial: {
		"& > *": {
			borderBottom: "unset",
			backgroundColor: theme.palette.custom.indicator.partial,
		},
	},
	none: {
		"& > *": {
			borderBottom: "unset",
			backgroundColor: theme.palette.custom.indicator.none,
		},
	},
	warn: {
		"& > *": {
			borderBottom: "unset",
			backgroundColor: theme.palette.custom.indicator.warn,
		},
	},
	over: {
		"& > *": {
			borderBottom: "unset",
			backgroundColor: theme.palette.custom.indicator.over,
		},
	},
	mismatch: {
		"& > *": {
			borderBottom: "unset",
			backgroundColor: theme.palette.custom.indicator.mismatch,
		},
	},
	fullBorder: {
		border: 0,
		borderStyle: "solid",
		borderColor: theme.palette.custom.border.full,
		borderLeftWidth: 2,
	},
	partialBorder: {
		border: 0,
		borderStyle: "solid",
		borderColor: theme.palette.custom.border.partial,
		borderLeftWidth: 2,
	},
	noneBorder: {
		border: 0,
		borderStyle: "solid",
		borderColor: theme.palette.custom.border.none,
		borderLeftWidth: 2,
	},
	warnBorder: {
		border: 0,
		borderStyle: "solid",
		borderColor: theme.palette.custom.border.warn,
		borderLeftWidth: 2,
	},
	overBorder: {
		border: 0,
		borderStyle: "solid",
		borderColor: theme.palette.custom.border.over,
		borderLeftWidth: 2,
	},
	mismatchBorder: {
		border: 0,
		borderStyle: "solid",
		borderColor: theme.palette.custom.border.mismatch,
		borderLeftWidth: 2,
	},
	productGroupAndDescriptionWidth: {
		width: "200px",
	},
	badgePadding: {
		padding: `0 10px 0 0`,
	},
	badge: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
	alertMismatchColor: { backgroundColor: "#e2cfef" },
	printLabelIcon: {
		fontSize: "1.1rem",
	},

	styledTableCell: {
		padding: 0,
	},
	highlight: {
		backgroundColor: theme.palette.custom.jbAppBar.background,
		color: theme.palette.getContrastText(theme.palette.custom.jbAppBar.background),
	},
	icon: {
		fontSize: 20,
		margin: "1px 0 0 0",
		color: theme.palette.custom.jbColours.darkOrange,
	},
	alert: {
		margin: "10px 0 0 0",
	},
	invoiceNumberInput: {
		textTransform: "uppercase",
	},
	dateInput: {
		color: theme.palette.text.primary,
	},
	invoiceCollapsePanelSummary: {
		minHeight: "48px",
		"&.Mui-expanded": {
			minHeight: "48px",
		},
		"& .MuiAccordionSummary-content": {
			margin: "12px 0",
			"&.Mui-expanded": {
				margin: "12px 0",
			},
		},
	},
	manualCollapsePanelSummary: {
		minHeight: "48px",
		"&.Mui-expanded": {
			minHeight: "48px",
		},
		"& .MuiAccordionSummary-content": {
			margin: "12px 0",
			"&.Mui-expanded": {
				margin: "12px 0",
			},
		},
	},
	caption: {
		padding: "0 0 3px 0"
	},
	value: {
		padding: "0 0 5px 0",
	},
	poNotes: {
		padding: "5px 0 0 0",
	},
	failureReasonGrid: {
		marginTop: "8px",
	},
}));
